import { render, staticRenderFns } from "./CustomerWsuReminder.vue?vue&type=template&id=954b34e4&scoped=true&"
import script from "./CustomerWsuReminder.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuReminder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWsuReminder.vue?vue&type=style&index=0&id=954b34e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954b34e4",
  null
  
)

export default component.exports